import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import ModulePageHeading from '../../components/ModulePageHeading';
import { queueBadgeClass, resolvePaperworkNav } from '../../navigation/paperworkNavigation';
import api from '../../utils/api';
import { formatSsLabel } from '../../utils/formatSsLabel';

export default function AdminPaperworkWorking() {

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['paperwork-admin-working'],
    queryFn: async () => (await api.get('/paperwork/admin/working')).data?.data,
  });

  const items = data?.items || [];

  return (
    <div>
      <ModulePageHeading
        resolveNav={resolvePaperworkNav}
        title="Paperwork"
        infoTitle="Working jobs"
        infoChildren={
          <p className="text-sm">
            Tasks you took from Overview. Finish each on its process page (memo + Confirm). Release
            returns it to Overview for someone else.
          </p>
        }
      />

      <div className="rounded-xl border bg-white overflow-hidden">
        {isLoading && <p className="px-4 py-8 text-sm text-gray-500">Loading…</p>}
        {isError && (
          <p className="px-4 py-8 text-sm text-red-600">
            {error?.response?.data?.error || 'Failed to load Working'}
          </p>
        )}
        {!isLoading && !isError && (
          <ul className="divide-y">
            {items.map((item) => (
              <li key={item.id}>
                <Link
                  to={`/paperwork/tasks/${item.id}`}
                  className="px-4 py-3 flex flex-wrap items-center gap-3 hover:bg-slate-50/80"
                >
                  <span
                    className={`inline-block rounded border px-2 py-0.5 text-xs font-semibold ${queueBadgeClass(
                      item.queue_type
                    )}`}
                  >
                    {item.queue_label || item.queue_type}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-gray-900 truncate">
                      {item.building_name || item.building_id}
                      {item.ss_code ? (
                        <>
                          {' · '}
                          <Link
                            to={`/paperwork/tasks/${item.id}?log=1`}
                            onClick={(e) => e.stopPropagation()}
                            className="text-primary-700 underline decoration-primary-200 hover:decoration-primary-600"
                            title="Work log"
                          >
                            {formatSsLabel(item.ss_code)}
                          </Link>
                        </>
                      ) : null}
                      {item.days_stuck != null ? ` · ${item.days_stuck}d` : ''}
                    </p>
                    <p className="text-xs text-gray-500 truncate">
                      Next: {item.next_action || '—'}
                    </p>
                  </div>
                  <span className="text-sm font-semibold text-primary-700 shrink-0">
                    Work on {item.assignee_name || 'you'}
                  </span>
                </Link>
              </li>
            ))}
            {!items.length && (
              <li className="px-4 py-10 text-center text-sm text-gray-500">
                No working jobs. Take a row from{' '}
                <Link to="/paperwork" className="text-primary-700 font-medium hover:underline">
                  Overview
                </Link>
                .
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
}
